<template>
    <div class="apprentice-simple-card">
        <div class="intro-text">
            <b-card
                class="intro-text"
                v-if="!preview">
                <b-card-text text-tag="div">
                    {{ $t('databank.view_shared_assignments') }}
                </b-card-text>
            </b-card>
        </div>

        <div class="assignments-databank container-with-shadow">
            <design-2021-databank-back-to-overview-component
                :preview-in="preview"
                @preview-status-update="previewStatusUpdate">
            </design-2021-databank-back-to-overview-component>

            <design-2021-assignments-databank-component
                :education-levels-in="educationLevelsIn"
                @update-preview-status="previewStatusUpdate"
                :preview-in="preview"
                :preview-mode-only="true">
            </design-2021-assignments-databank-component>

            <design-2021-databank-back-to-overview-component
                :preview-in="preview"
                @preview-status-update="previewStatusUpdate">
            </design-2021-databank-back-to-overview-component>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-databank-component',
    props: {
        educationLevelsIn: Array,
    },
    data() {
        return {
            preview: false,
        };
    },
    methods: {
        previewStatusUpdate(status) {
            this.preview = status;
        },

        returnToBank() {
            this.preview = !this.preview;
        },
    },
};
</script>

<style scoped lang="scss">
.intro-text {
    color: $text-color;
    line-height: 1.3;
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

@media (min-width: 1200px) {
    .intro-text .card-text {
        max-inline-size: 106ch;
    }
}
</style>
